export function onlyUnique (value, index, array) {
  return array.indexOf(value) === index
}

export const JOBS = ['cleaning', 'maintenance', 'municipacility', 'territory_responsable', 'emergency']
